import { DatePicker, TimePicker } from '@mui/lab';
import { Grid } from '@mui/material';
import { SubjectIcaroVM } from 'civil-status/view-models/form-declaration-icaro';
import { FormikErrors, FormikTouched } from 'formik';
import { memo } from 'react';
import PmiTextField from 'shell/components/shared/text-field';

interface FormBornProps {
  disabled?: boolean;
  values?: SubjectIcaroVM;
  errors?: FormikErrors<SubjectIcaroVM>;
  touched?: FormikTouched<SubjectIcaroVM>;
  onChange: (key: keyof SubjectIcaroVM, value: SubjectIcaroVM[keyof SubjectIcaroVM]) => void;
}

const FormBornComponent = ({
  disabled,
  values,
  errors,
  touched,
  onChange,
}: FormBornProps): React.ReactElement => {
  return (
    <Grid container spacing={2} item>
      <Grid item xs={12} md={4}>
        <PmiTextField
          label="Matricola"
          aria-label="Matricola"
          id="freshman"
          name="freshman"
          fullWidth
          disabled={disabled}
          helperText={errors?.freshman}
          error={touched?.freshman && Boolean(errors?.freshman)}
          type="text"
          variant="outlined"
          value={values?.freshman || ''}
          onChange={(event) => {
            onChange('freshman', event.target.value);
          }}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <PmiTextField
          label="Num. famiglia"
          aria-label="Num. famiglia"
          id="numberFamily"
          name="numberFamily"
          fullWidth
          disabled={disabled}
          helperText={errors?.numberFamily}
          error={touched?.numberFamily && Boolean(errors?.numberFamily)}
          type="text"
          variant="outlined"
          value={values?.numberFamily || ''}
          onChange={(event) => {
            onChange('numberFamily', event.target.value);
          }}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <PmiTextField
          label="Num. atto"
          aria-label="Num. atto"
          id="numberAct"
          name="numberAct"
          fullWidth
          disabled={disabled}
          helperText={errors?.numberAct}
          error={touched?.numberAct && Boolean(errors?.numberAct)}
          type="text"
          variant="outlined"
          value={values?.numberAct || ''}
          onChange={(event) => {
            onChange('numberAct', event.target.value);
          }}
        />
      </Grid>
      <Grid item xs={12}>
        <PmiTextField
          label="Cognome"
          aria-label="Cognome"
          id="surname"
          name="surname"
          fullWidth
          disabled={disabled}
          helperText={errors?.surname}
          error={touched?.surname && Boolean(errors?.surname)}
          type="text"
          variant="outlined"
          value={values?.surname || ''}
          onChange={(event) => {
            onChange('surname', event.target.value);
          }}
        />
      </Grid>
      <Grid item xs={12}>
        <PmiTextField
          label="Nome"
          aria-label="Nome"
          id="name"
          name="name"
          fullWidth
          disabled={disabled}
          helperText={errors?.name}
          error={touched?.name && Boolean(errors?.name)}
          type="text"
          variant="outlined"
          value={values?.name || ''}
          onChange={(event) => {
            onChange('name', event.target.value);
          }}
        />
      </Grid>
      <Grid item xs={12}>
        <PmiTextField
          label="Nome affettivo"
          aria-label="Nome affettivo"
          id="nameAffective"
          name="nameAffective"
          fullWidth
          disabled={disabled}
          helperText={errors?.nameAffective}
          error={touched?.nameAffective && Boolean(errors?.nameAffective)}
          type="text"
          variant="outlined"
          value={values?.nameAffective || ''}
          onChange={(event) => {
            onChange('nameAffective', event.target.value);
          }}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <PmiTextField
          label="Sesso"
          aria-label="Sesso"
          id="gender"
          name="gender"
          fullWidth
          disabled={disabled}
          helperText={errors?.gender}
          error={touched?.gender && Boolean(errors?.gender)}
          type="text"
          variant="outlined"
          value={values?.gender || ''}
          onChange={(event) => {
            onChange('gender', event.target.value);
          }}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <PmiTextField
          label="Numero gemello"
          aria-label="Numero gemello"
          id="numberTwins"
          name="numberTwins"
          fullWidth
          disabled={disabled}
          helperText={errors?.numberTwins}
          error={touched?.numberTwins && Boolean(errors?.numberTwins)}
          type="text"
          variant="outlined"
          value={values?.numberTwins || ''}
          onChange={(event) => {
            onChange('numberTwins', event.target.value);
          }}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <DatePicker
          label="Data nascita"
          aria-label="Data nascita"
          value={values?.dateBorn || null}
          onChange={(date) => {
            onChange('dateBorn', date);
          }}
          disabled={disabled}
          renderInput={(params) => (
            <PmiTextField
              {...params}
              id="dateBorn"
              fullWidth
              helperText={errors?.dateBorn}
              error={touched?.dateBorn && Boolean(errors?.dateBorn)}
            />
          )}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <TimePicker
          label="Ora nascita"
          aria-label="Ora nascita"
          value={values?.timeBorn || null}
          onChange={(date) => {
            onChange('timeBorn', date);
          }}
          disabled={disabled}
          renderInput={(params) => (
            <PmiTextField
              id="timeBorn"
              {...params}
              fullWidth
              error={touched?.timeBorn && Boolean(errors?.timeBorn)}
              helperText={errors?.timeBorn}
            />
          )}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <PmiTextField
          label="Luogo nascita"
          aria-label="Luogo nascita"
          id="placeBorn"
          name="placeBorn"
          fullWidth
          disabled={disabled}
          helperText={errors?.placeBorn}
          error={touched?.placeBorn && Boolean(errors?.placeBorn)}
          type="text"
          variant="outlined"
          value={values?.placeBorn || ''}
          onChange={(event) => {
            onChange('placeBorn', event.target.value);
          }}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <PmiTextField
          label="Comune nascita"
          aria-label="Comune nascita"
          id="municipalityBorn"
          name="municipalityBorn"
          fullWidth
          disabled={disabled}
          helperText={errors?.municipalityBorn}
          error={touched?.municipalityBorn && Boolean(errors?.municipalityBorn)}
          type="text"
          variant="outlined"
          value={values?.municipalityBorn || ''}
          onChange={(event) => {
            onChange('municipalityBorn', event.target.value);
          }}
        />
      </Grid>
      {/* <Grid item xs={12} md={2}>
        <PmiTextField
          label="Provincia nascita"
          aria-label="Provincia nascita"
          id="provinceBorn"
          name="provinceBorn"
          fullWidth
          disabled={disabled}
          helperText={errors?.provinceBorn}
          error={touched?.provinceBorn && Boolean(errors?.provinceBorn)}
          type="text"
          variant="outlined"
          value={values?.provinceBorn || ''}
          onChange={(event) => {
            onChange('provinceBorn', event.target.value);
          }}
        />
      </Grid> */}
    </Grid>
  );
};

FormBornComponent.displayName = 'Subject Icaro - Form Born Component';

const FormBorn = memo(FormBornComponent);

export default FormBorn;
